import { render, staticRenderFns } from "./ImgPred.vue?vue&type=template&id=49e66d22&scoped=true&"
import script from "./ImgPred.vue?vue&type=script&lang=js&"
export * from "./ImgPred.vue?vue&type=script&lang=js&"
import style0 from "./ImgPred.vue?vue&type=style&index=0&id=49e66d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e66d22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VImg,VLayout,VProgressCircular})
